import type { TreeNode } from "primeng/api";

export interface SerializedNode<TData> {
  node: TreeNode<TData>;
  parent: TreeNode<TData> | undefined;
  level: number;
  visible: boolean;
  firstChild: boolean;
  lastChild: boolean;
  index: number;
}

export function serializeNodes<TData>(
  parent: TreeNode<TData> | undefined,
  nodes: TreeNode<TData>[] | undefined,
  level: number,
  visible: boolean,
) {
  const workingSet: SerializedNode<TData>[] = [];
  if (nodes?.length) {
    for (const [index, node] of nodes.entries()) {
      node.parent = parent;
      const rowNode = {
        node: node,
        parent: parent,
        level: level,
        visible: visible ? (parent ? (parent.expanded ?? false) : true) : false,
        firstChild: index === 0,
        lastChild: index === nodes.length - 1,
        index: index,
      } satisfies SerializedNode<TData>;
      workingSet.push(rowNode);

      if (rowNode.visible && node.expanded) {
        const res = serializeNodes<TData>(
          node,
          node.children,
          level + 1,
          rowNode.visible,
        );
        for (const child of res) {
          workingSet.push(child);
        }
      }
    }
  }

  return workingSet;
}
